import * as React from 'react';
import { AdditionalWeeksReason, WageAndTravelReimbursementRequestStatus } from '@nkr/enums/index';
import { IListItem } from '@nkr/models/index';
import { FormControl, FormGroup, ControlLabel, HelpBlock } from 'react-bootstrap';
import { IItem } from './types';

interface IProps {
    activeItem: IItem;
    reasons: IListItem[];
    requiresReason: boolean;
    reasonMissing: boolean;
    formSectionLabelStyle: React.CSSProperties;
    onStatusChange: (id: number, status: WageAndTravelReimbursementRequestStatus, weeks: number[]) => void;
    onReasonChange: (id: number, additionalWeeksReason: number | null, weeks: number[]) => void;
    onReasonOtherChange: (id: number, additionalWeeksReasonOther: string, weeks: number[]) => void;
}

const ReviewDecisionFields = ({
    activeItem,
    reasons,
    requiresReason,
    reasonMissing,
    formSectionLabelStyle,
    onStatusChange,
    onReasonChange,
    onReasonOtherChange
}: IProps) => (
    <div style={{ marginBottom: 20 }}>
        <FormGroup>
            <ControlLabel style={formSectionLabelStyle}>Decision</ControlLabel>
            <FormControl
                componentClass='select'
                bsSize='sm'
                value={activeItem.status}
                onChange={(e: React.FormEvent<FormControl & HTMLSelectElement>) =>
                    onStatusChange(activeItem.requestId, parseInt(e.currentTarget.value, 10), activeItem.weeks)
                }
                style={{ maxWidth: 360 }}
            >
                <option value={WageAndTravelReimbursementRequestStatus.PendingApproval}>- Select -</option>
                <option value={WageAndTravelReimbursementRequestStatus.CenterApproved}> Approved </option>
                <option value={WageAndTravelReimbursementRequestStatus.CenterDeclined}> Declined </option>
            </FormControl>
        </FormGroup>
        {activeItem.status == WageAndTravelReimbursementRequestStatus.CenterApproved && requiresReason &&
            <FormGroup>
                <ControlLabel style={formSectionLabelStyle}>Reason for additional week(s)</ControlLabel>
                <FormControl
                    componentClass='select'
                    bsSize='sm'
                    value={activeItem.additionalWeeksReason ?? ''}
                    onChange={(e: React.FormEvent<FormControl & HTMLSelectElement>) => {
                        const raw = e.currentTarget.value;
                        onReasonChange(activeItem.requestId, raw === '' ? null : parseInt(raw, 10), activeItem.weeks);
                    }}
                    style={{ maxWidth: 420 }}
                >
                    <option value=''>- Select Reason -</option>
                    {reasons.map((r) => (
                        <option key={r.id} value={r.id}>{r.description}</option>
                    ))}
                </FormControl>
            </FormGroup>
        }
        {activeItem.status == WageAndTravelReimbursementRequestStatus.CenterApproved && requiresReason && activeItem.additionalWeeksReason == AdditionalWeeksReason.Other &&
            <FormGroup>
                <ControlLabel style={formSectionLabelStyle}>Specify other</ControlLabel>
                <FormControl
                    type='text'
                    bsSize='sm'
                    placeholder='Please specify'
                    maxLength={140}
                    value={activeItem.additionalWeeksReasonOther ?? ''}
                    onChange={(e: React.FormEvent<FormControl & HTMLInputElement>) =>
                        onReasonOtherChange(activeItem.requestId, e.currentTarget.value, activeItem.weeks)
                    }
                    style={{ maxWidth: 420 }}
                />
            </FormGroup>
        }
    </div>
);

export default ReviewDecisionFields;
